import { render } from "./NoResults.vue?vue&type=template&id=5141dfff&scoped=true"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"

import "./NoResults.vue?vue&type=style&index=0&id=5141dfff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5141dfff"]])

export default __exports__